// @flow
import Properties from "../../../Properties";
import {
  getInit,
  postInit,
  graphQLInit,
  putInit,
  deleteInit
} from "../../global/types/constants";
import type { DispatchType } from "../../global/types/redux";
import { apiFailCallbackHandle } from "../../account/containers/ErrosDisplay";
import {
  LicenceNode,
  LicenceAdminNode,
  CompanyInfoNode
} from "../../account/types/GraphQlNodes";
import {
  ADMIN_UPDATE_COMPANY_LICENCE,
  ADMIN_DELETE_LICENCE_FROM_COMPANY,
  ADMIN_REMOVE_LICENCE_FROM_FACEBASE,
  ADMIN_GET_LICENCE_LIST,
  ADMIN_UPDATE_LICENCE_ITEM,
  ADMIN_DELETE_LICENCE_ITEM,
  REMOVE_COMPANY_LICENCE,
  UPDATE_COMPANY_LICENCE
} from "../../global/actions/actionNames";

const root = Properties.api_root;

export const fetchLicenceList = (callback?: Function): * => (
  dispatch: DispatchType
): DispatchType => {
  const graphQl = `
  {
    licences {
      ${LicenceNode}
      ${LicenceAdminNode}
    }
  }
  `;
  return fetch(`${root}/api/v2/company/graphql`, graphQLInit(graphQl))
    .then((response) => response.json())
    .then((json) => {
      dispatch({ type: ADMIN_GET_LICENCE_LIST, licences: json.data.licences });
      callback && callback(json.data.licences);
    });
};

export const updateLicence = (
  licenceId: string,
  expiry_date: Date,
  start_date: Date,
  additional_slot: number,
  auto_assign: boolean,
  licence_type: string,
  camera_count: number,
  face_count: number,
  modules: Array<*>,
  doneCallback: Function,
  failCallBack: Function,
  companyId: string,
  reduxAction: string
): * => (dispatch: DispatchType): * => {
  let moduleNode = "";
  if (!!modules) {
    const moduleList = modules.map(
      (item: *): * =>
        `{name : "${item.name}", version : "${item.version}", data: "${item.data}"}`
    );
    moduleNode = `modules: [${moduleList}]`;
  }

  const graphQl = `
  mutation {
    updateLicence(
      licenceId: "${licenceId}",
      expiryDate: "${expiry_date}",
      startDate: "${start_date}",
      additionalDeviceCount: ${additional_slot},
      autoAssign: ${auto_assign},
      licenceType: ${licence_type},
      noOfStreams: ${camera_count},
      noOfFaces: ${face_count},
      ${moduleNode}
    ){
      ok
      errors {
        field
        message
      }
      licence {
        ${LicenceNode}
        ${LicenceAdminNode}
      }
    }
  }
  `;
  return fetch(`${root}/api/v2/company/graphql`, graphQLInit(graphQl))
    .then((response) => response.json())
    .then((json) => {
      if (json.errors) {
        failCallBack && failCallBack(apiFailCallbackHandle(json.errors));
      } else {
        const result = json.data.updateLicence;
        if (result.ok) {
          if (reduxAction === "adminCompany") {
            dispatch({
              type: ADMIN_UPDATE_COMPANY_LICENCE,
              data: result.licence,
              companyId: companyId
            });
          } else if (reduxAction === "adminLicence") {
            dispatch({ type: ADMIN_UPDATE_LICENCE_ITEM, data: result.licence });
          } else if (reduxAction === "company") {
            dispatch({ type: UPDATE_COMPANY_LICENCE, data: result.licence });
          }
          doneCallback && doneCallback();
        } else {
          failCallBack && failCallBack(apiFailCallbackHandle(result.errors));
        }
      }
    })
    .catch((err) => {
      failCallBack && failCallBack(apiFailCallbackHandle(err.message));
    });
};

export function deleteLicence(
  licenceid: string,
  licenceuuid: string,
  doneBack: Function,
  failBack: Function,
  companyId?: string | null = null,
  facebaseId?: string | null = null,
  isAdminLicence?: boolean = false
): * {
  return (dispatch: any) => {
    fetch(root + "/auth/v2/licences/" + licenceuuid, deleteInit())
      .then((response) => response.json())
      .then(function (json) {
        if (json.errors) {
          failBack && failBack(apiFailCallbackHandle(json.errors, "licence"));
        } else {
          if (companyId) {
            dispatch({
              type: ADMIN_DELETE_LICENCE_FROM_COMPANY,
              licenceid: licenceid,
              companyId: companyId
            });
          } else if (facebaseId) {
            dispatch({
              type: ADMIN_REMOVE_LICENCE_FROM_FACEBASE,
              licenceId: licenceuuid,
              facebaseId: facebaseId
            });
          } else if (isAdminLicence) {
            dispatch({ type: ADMIN_DELETE_LICENCE_ITEM, licenceid: licenceid });
          } else {
            dispatch({
              type: REMOVE_COMPANY_LICENCE,
              licenceId: licenceid
            });
          }
          doneBack && doneBack();
        }
      })
      .catch((err) => {
        failBack && failBack(apiFailCallbackHandle(err.message, "licence"));
      });
  };
}

export const fetchLicenceCompanyDetail = (
  licenceId: string,
  callback?: Function
): * => (dispatch: DispatchType): * => {
  const graphQl = `
  {
    node(id: "${licenceId}") {
      ... on Licence {
        ${LicenceNode}
        company {
          ${CompanyInfoNode}
        }
      }
    }
  }
  `;
  return fetch(`${root}/api/v2/company/graphql`, graphQLInit(graphQl))
    .then((response) => response.json())
    .then((json) => {
      callback && callback(json.data.node);
    });
};

export function emailLicenceFile(
  host_id: string,
  licenceId: string,
  email_address: string,
  username: string,
  subject: string,
  email_content: string,
  is_old: boolean,
  doneCall: Function,
  failBack: Function
): * {
  let postFormData = new FormData();
  postFormData.append("email_address", email_address);
  postFormData.append("username", username);
  postFormData.append("subject", subject);
  postFormData.append("email_content", email_content);
  postFormData.append("is_old", is_old);
  return (dispatch: DispatchType) => {
    fetch(
      root +
        "/api/v2/company/licences/" +
        licenceId +
        "/email?host_id=" +
        host_id,
      postInit(postFormData)
    )
      .then((response) => response.json())
      .then(function (json) {
        if (json.errors) {
          failBack && failBack(apiFailCallbackHandle(json.errors, "licence"));
        } else {
          doneCall && doneCall();
        }
      })
      .catch((err) => {
        failBack && failBack(apiFailCallbackHandle(err.message, "licence"));
      });
  };
}

export const deleteLicenceHistory = (
  licenceId: string,
  historyId: string,
  doneCallback: Function,
  failCallBack: Function,
  reduxAction: string,
  companyId?: string
): * => (dispatch: DispatchType, getState: *): * => {
  const graphQl = `
    mutation {
      deleteLicenceHistory(
        licenceId: "${licenceId}",
        licenceHistoryId: "${historyId}"
      ){
        ok
        errors {
          field
          message
        }
        licence {
          ${LicenceNode}
          ${LicenceAdminNode}
        }
      }
    }
    `;
  return fetch(`${root}/api/v2/company/graphql`, graphQLInit(graphQl))
    .then((response: Response): Promise<JSON> => response.json())
    .then((json: JSON) => {
      if (json.errors) {
        failCallBack && failCallBack(apiFailCallbackHandle(json.errors));
      } else {
        const result = json.data.deleteLicenceHistory;
        if (result.ok) {
          if (reduxAction === "adminCompany") {
            dispatch({
              type: ADMIN_UPDATE_COMPANY_LICENCE,
              data: result.licence,
              companyId: companyId
            });
          } else if (reduxAction === "adminLicence") {
            dispatch({ type: ADMIN_UPDATE_LICENCE_ITEM, data: result.licence });
          } else if (reduxAction === "company") {
            dispatch({ type: UPDATE_COMPANY_LICENCE, data: result.licence });
          }

          doneCallback && doneCallback();
        } else {
          failCallBack && failCallBack(apiFailCallbackHandle(result.errors));
        }
      }
    })
    .catch((err: *) => {
      failCallBack && failCallBack(apiFailCallbackHandle(err.message));
    });
};
